/**
 * 目次パネル（FR-UI-06）。マニフェストの outline をそのまま木構造で見せる。
 */
import { cls } from '../brand';
import type { DisposeRegistry } from '../core/dispose-registry';
import type { OutlineNode } from '../core/manifest';
import type { ViewerApi } from './api';
import type { PanelContent } from './panels';

export class Outline implements PanelContent {
  readonly el: HTMLElement;

  constructor(
    doc: Document,
    private readonly registry: DisposeRegistry,
    private readonly api: ViewerApi,
    nodes: readonly OutlineNode[],
  ) {
    this.el = doc.createElement('nav');
    this.el.className = cls('outline');
    this.el.appendChild(this.list(doc, nodes));
  }

  dispose(): void {
    this.el.remove();
  }

  private list(doc: Document, nodes: readonly OutlineNode[]): HTMLUListElement {
    const ul = doc.createElement('ul');
    ul.className = cls('outline-list');
    for (const node of nodes) {
      const li = doc.createElement('li');
      const button = doc.createElement('button');
      button.type = 'button';
      button.className = cls('outline-item');
      button.textContent = node.title;
      this.registry.listen(button, 'click', () => this.api.goto(node.page));
      li.appendChild(button);
      if (node.children?.length) li.appendChild(this.list(doc, node.children));
      ul.appendChild(li);
    }
    return ul;
  }
}
